import {getPMSBaseUrl} from '../../../services/apiService'
import {createFetchActions} from '../../../services/createActions'
import {get} from '../../../services/createAPICall'

export const GET_BUSINESS_DATES = createFetchActions('GET_BUSINESS_DATES')
export const FETCH_RECALL_SUMMARY_DATA = createFetchActions('FETCH_RECALL_SUMMARY_DATA')
export const SET_BUSINESS_DATE = createFetchActions('SET_BUSINESS_DATE')
export const SET_SECURITY = createFetchActions('SET_SECURITY')
export const SET_SECURITY_OPTIONS = createFetchActions('SET_SECURITY_OPTIONS')

export const getBusinessDates = () => (dispatch: any) => {
	return dispatch(get(GET_BUSINESS_DATES, `${getPMSBaseUrl()}/v1/pms/recall/business-dates`))
}

export const fetchRecallSummaryData = (businessDate: string, selectedSecurity: any) => (dispatch: any) => {
	let url = `${getPMSBaseUrl()}/v1/pms/recall/summary?businessDate=${businessDate}`
	if (!!selectedSecurity && !!selectedSecurity.securityId) {
		url += `&cusip=${selectedSecurity.securityId}`
	}
	return dispatch(get(FETCH_RECALL_SUMMARY_DATA, url))
}

export const setBusinessDate = (businessDate: string) => {
	return {
		type: SET_BUSINESS_DATE,
		payload: businessDate,
	}
}

export const setSecurity = (security: any) => {
	return {
		type: SET_SECURITY,
		payload: security,
	}
}
export const setSecurityOptions = (securityOptions: any[]) => {
	return {
		type: SET_SECURITY_OPTIONS,
		payload: securityOptions,
	}
}
